
$(function () {
  const acc = $('.hs-benefits-right-sdie-content-accordian');
  const bodies = acc.find(
    '.hs-benefits-right-sdie-content-accordian-description-area'
  );

  bodies.hide();
  acc.removeClass('active');

  acc.on(
    'click',
    '.hs-benefits-right-sdie-content-accordian-title-area',
    function () {
      const item = $(this).parent();
      const body = item.find(
        '.hs-benefits-right-sdie-content-accordian-description-area'
      );

      if (item.hasClass('active')) {
        item.removeClass('active');
        body.slideUp(200);
      } else {
        acc.removeClass('active');
        bodies.slideUp(200);
        item.addClass('active');
        body.slideDown(200);
      }
    }
  );
});


$(document).ready(function () {
  $(".hs-product-qa-left-side-questioniar-title-block").click(function () {
    const parent = $(this).closest(
      ".hs-product-qa-left-side-questioniar"
    );

    const answer = parent.find(
      ".hs-product-qa-left-side-questioniar-answer-block"
    );

    $(".hs-product-qa-left-side-questioniar-answer-block")
      .not(answer)
      .slideUp();

    $(".hs-product-qa-left-side-questioniar")
      .not(parent)
      .removeClass("active");

    answer.slideToggle();
    parent.toggleClass("active");
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const recommendationElement = document.querySelector(
    ".hs-product-recommendation-slider"
  );

  if (
    recommendationElement &&
    typeof Swiper !== "undefined"
  ) {
    new Swiper(recommendationElement, {
      slidesPerView: 3,
      spaceBetween: 60,

      navigation: {
        nextEl: ".hs-product-recommendation-slider-next-btn",
        prevEl: ".hs-product-recommendation-slider-pre-btn"
      },

      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20
        },

        820: {
          slidesPerView: 2,
          spaceBetween: 40
        },

        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        },

        1281: {
          slidesPerView: 3,
          spaceBetween: 40
        }
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener(
    'product-recommendations:loaded',
    function () {
      if (
        window.yotpo &&
        window.yotpo.refreshWidgets
      ) {
        window.yotpo.refreshWidgets();
      }
    }
  );
});


$(document).ready(function () {
  $('.hs-ingredients-right-side-accordian-title-block')
    .click(function () {
      const parent = $(this).closest(
        '.hs-ingredients-right-side-accordian'
      );

      const content = parent.find(
        '.hs-ingredients-right-side-accordian-des-block'
      );

      $('.hs-ingredients-right-side-accordian-des-block')
        .not(content)
        .slideUp();

      $('.hs-ingredients-right-side-accordian')
        .not(parent)
        .removeClass('active');

      parent.toggleClass('active');
      content.stop(true, true).slideToggle();
    });
});


/* ==========================================================
   PRODUCT GALLERY AND VARIANT SWITCHING
========================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const productRoots = document.querySelectorAll(
    "[data-hs-product-info]"
  );

  productRoots.forEach(function (root) {
    initHsProductInfo(root);
  });
});


function initHsProductInfo(root) {

  /*
   * NMX PRO 2026-11-02
   * Initialize variant availability independently of Swiper,
   * so purchasing logic works even if the gallery fails.
   */
  initHsVariantButtons(root, null, null);

  const thumbsElement = root.querySelector(
    ".hs-product-info-slidershow-thumbs-swiper"
  );

  const mainElement = root.querySelector(
    ".hs-product-info-slidershow-main-swiper"
  );

  if (
    !thumbsElement ||
    !mainElement ||
    typeof Swiper === "undefined"
  ) {
    return;
  }

  const previousButton = root.querySelector(
    ".hs-product-info-main-prev"
  );

  const nextButton = root.querySelector(
    ".hs-product-info-main-next"
  );

  const thumbSwiper = new Swiper(thumbsElement, {
    direction: "vertical",
    spaceBetween: 12,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true
  });

  const mainSwiper = new Swiper(mainElement, {
    slidesPerView: 1,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,

    thumbs: {
      swiper: thumbSwiper
    },

    navigation: {
      nextEl: nextButton,
      prevEl: previousButton
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      1025: {
        slidesPerView: 1,
        spaceBetween: 0
      },

      1281: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  });

  /*
   * NMX PRO 2026-11-02
   * ORIGINAL CODE - COMMENTED FOR SAFETY.
   * Initialization now happens before the Swiper check.
   *
   * initHsVariantButtons(
   *   root,
   *   mainSwiper,
   *   thumbSwiper
   * );
   */

  root.hsMainSwiper = mainSwiper;
  root.hsThumbSwiper = thumbSwiper;

  const selectedVariantButton = root.querySelector(
    ".variant-btn.selected"
  );

  if (selectedVariantButton) {
    changeHsVariantImage(
      root,
      selectedVariantButton.dataset.imageId,
      mainSwiper,
      thumbSwiper,
      false
    );
  }
}


function initHsVariantButtons(
  root,
  mainSwiper,
  thumbSwiper
) {
  const variantButtons = root.querySelectorAll(
    ".variant-btn"
  );

  const variantSelects = root.querySelectorAll(
    ".variant-select"
  );

  const variantIdInput = root.querySelector(
    "input[name='id']"
  );

  /*
   * NMX PRO 2026-11-02
   * ORIGINAL GUARD - COMMENTED.
   *
   * if (
   *   !variantIdInput ||
   *   (variantButtons.length === 0 &&
   *     variantSelects.length === 0)
   * ) {
   *   return;
   * }
   *
   * Changed to support single-variant products.
   */
  if (!variantIdInput) {
    return;
  }

  /*
   * NMX PRO 2026-11-02
   * Initialize native Shopify availability on page load.
   */
  updateHsPurchaseAvailability(
    root,
    root.dataset.selectedVariantAvailable === "true"
  );

  /*
   * Prevent out-of-stock form submission.
   */
  const productForm = variantIdInput.closest("form");

  if (productForm) {
    productForm.addEventListener(
      "submit",
      function (event) {
        const atc = root.querySelector("[data-product-atc]");

        if (atc && atc.disabled) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );
  }

  let requestToken = 0;

  /*
   * NMX PRO 2026-11-02
   * Original function signature:
   *
   * function selectHsVariant(variantId, imageId) {
   *
   * Added the selected variant's native availability.
   */
  function selectHsVariant(variantId, imageId, available) {
    if (!variantId) {
      return;
    }

    variantButtons.forEach(function (item) {
      item.classList.toggle(
        "selected",
        item.dataset.variantId === variantId
      );
    });

    /*
     * NMX PRO 2026-11-02
     * Immediately update availability before the
     * asynchronous tier-price request.
     */
    updateHsPurchaseAvailability(root, available === "true");

    variantIdInput.value = variantId;
    variantIdInput.setAttribute("value", variantId);

    variantIdInput.dispatchEvent(
      new Event("input", { bubbles: true })
    );

    variantIdInput.dispatchEvent(
      new Event("change", { bubbles: true })
    );

    /*
     * NMX PRO 2026-11-02
     * ORIGINAL GALLERY CALL - COMMENTED.
     *
     * changeHsVariantImage(
     *   root,
     *   imageId,
     *   mainSwiper,
     *   thumbSwiper,
     *   true
     * );
     *
     * Use the initialized Swiper instances when available.
     */
    if (root.hsMainSwiper && root.hsThumbSwiper) {
      changeHsVariantImage(
        root,
        imageId,
        root.hsMainSwiper,
        root.hsThumbSwiper,
        true
      );
    }

    updateHsVariantUrl(variantId);

    updateSectionForVariant(
      root,
      variantId,
      ++requestToken,
      function () {
        return requestToken;
      }
    );
  }

  variantButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      /*
       * ORIGINAL CODE - COMMENTED.
       *
       * selectHsVariant(
       *   button.dataset.variantId,
       *   button.dataset.imageId
       * );
       */

      // NMX PRO: pass Shopify variant availability.
      selectHsVariant(
        button.dataset.variantId,
        button.dataset.imageId,
        button.dataset.variantAvailable
      );
    });
  });

  variantSelects.forEach(function (select) {
    select.addEventListener("change", function () {
      const option = select.options[select.selectedIndex];

      /*
       * ORIGINAL CODE - COMMENTED.
       *
       * selectHsVariant(
       *   select.value,
       *   option ? option.dataset.imageId : ""
       * );
       */

      // NMX PRO: supports dropdown availability.
      selectHsVariant(
        select.value,
        option ? option.dataset.imageId : "",
        option ? option.dataset.variantAvailable : "false"
      );
    });
  });
}


/* ==========================================================
   NMX PRO 2026-11-02
   NEW: SHOPIFY NATIVE VARIANT AVAILABILITY
========================================================== */

function updateHsPurchaseAvailability(root, available) {
  const purchaseWrapper = root.querySelector(
    "[data-product-purchase-wrapper]"
  );

  const quantityBlock = root.querySelector(
    "[data-product-quantity]"
  );

  const atcButton = root.querySelector(
    "[data-product-atc]"
  );

  if (!purchaseWrapper || !atcButton) {
    return;
  }

  purchaseWrapper.classList.toggle(
    "is-sold-out",
    !available
  );

  if (quantityBlock) {
    quantityBlock.style.display = available ? "" : "none";
  }

  atcButton.disabled = !available;

  if (available) {
    atcButton.removeAttribute("aria-disabled");

    /*
     * The Pro tier-aware price is restored by
     * updateSectionForVariant after the fetch completes.
     */
    atcButton.textContent = "ADD TO CART";
  } else {
    atcButton.setAttribute("aria-disabled", "true");
    atcButton.textContent = "Temporarily Out of Stock";
  }
}


function changeHsVariantImage(
  root,
  imageId,
  mainSwiper,
  thumbSwiper,
  animate
) {
  if (!imageId) {
    console.warn(
      "The selected variant does not have an assigned image."
    );

    return;
  }

  const mainSlides = Array.from(
    root.querySelectorAll(
      ".hs-product-info-slidershow-main-slide"
    )
  );

  const targetIndex = mainSlides.findIndex(
    function (slide) {
      return (
        String(slide.dataset.imageId) ===
        String(imageId)
      );
    }
  );

  if (targetIndex === -1) {
    console.warn(
      "Variant image was not found inside the product gallery:",
      imageId
    );

    return;
  }

  const speed = animate ? 350 : 0;

  mainSwiper.update();
  thumbSwiper.update();

  mainSwiper.slideTo(
    targetIndex,
    speed
  );

  thumbSwiper.slideTo(
    targetIndex,
    speed
  );
}


function updateHsVariantUrl(variantId) {
  const currentUrl = new URL(
    window.location.href
  );

  currentUrl.searchParams.set(
    "variant",
    variantId
  );

  window.history.replaceState(
    {},
    "",
    currentUrl.toString()
  );
}


/* ==========================================================
   PRODUCT QUANTITY
========================================================== */

document.addEventListener("DOMContentLoaded", function () {
  const qtyBlocks = document.querySelectorAll(
    ".hs-product-info-content-product-quantity-block"
  );

  qtyBlocks.forEach(function (block) {
    const minusBtn = block.querySelector(
      ".pre-quantity-btn"
    );

    const plusBtn = block.querySelector(
      ".next-quantity-btn"
    );

    const qtyInput = block.querySelector(
      ".input-quantity"
    );

    if (!qtyInput) {
      return;
    }

    const updateValue = function (newValue) {
      qtyInput.value = newValue;

      qtyInput.setAttribute(
        "value",
        newValue
      );

      qtyInput.dispatchEvent(
        new Event("input", {
          bubbles: true
        })
      );

      qtyInput.dispatchEvent(
        new Event("change", {
          bubbles: true
        })
      );
    };

    if (minusBtn) {
      minusBtn.addEventListener(
        "click",
        function (event) {
          event.preventDefault();

          const currentValue =
            parseInt(qtyInput.value, 10) || 1;

          if (currentValue > 1) {
            updateValue(currentValue - 1);
          }
        }
      );
    }

    if (plusBtn) {
      plusBtn.addEventListener(
        "click",
        function (event) {
          event.preventDefault();

          const currentValue =
            parseInt(qtyInput.value, 10) || 1;

          updateValue(currentValue + 1);
        }
      );
    }

    qtyInput.addEventListener(
      "input",
      function () {
        const currentValue =
          parseInt(qtyInput.value, 10) || 0;

        if (currentValue < 1) {
          updateValue(1);
        }
      }
    );
  });
});


/* ==========================================================
   VARIANT PRICE UPDATE
========================================================== */

function updateSectionForVariant(
  root,
  variantId,
  token,
  getLatestToken
) {
  const sectionId = root.dataset.sectionId;
  const productUrl = root.dataset.productUrl;

  if (!sectionId || !productUrl) {
    return;
  }

  const requestUrl =
    productUrl +
    "?variant=" +
    encodeURIComponent(variantId) +
    "&section_id=" +
    encodeURIComponent(sectionId);

  fetch(requestUrl)
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          "HTTP " + response.status
        );
      }

      return response.text();
    })
    .then(function (html) {
      if (token !== getLatestToken()) {
        return;
      }

      const parsed = new DOMParser()
        .parseFromString(
          html,
          "text/html"
        );

      const newRoot =
        parsed.querySelector(
          "[data-hs-product-info]"
        ) || parsed;

      swapHsContent(
        root,
        newRoot,
        ".hs-product-info-content-price-block"
      );

      /*
       * NMX PRO 2026-11-02
       * ORIGINAL PRICE-ONLY SWAP - COMMENTED FOR SAFETY.
       *
       * swapHsContent(
       *   root,
       *   newRoot,
       *   ".hs-atc-price"
       * );
       */

      /*
       * NMX PRO 2026-11-02
       * Restore the original Pro tier-aware CTA HTML
       * after switching to an available variant.
       */
      const currentAtc = root.querySelector(
        "[data-product-atc]"
      );

      const fetchedAtc = newRoot.querySelector(
        "[data-product-atc]"
      );

      const selectedIdInput = root.querySelector(
        "input[name='id']"
      );

      const fetchedIdInput = newRoot.querySelector(
        "input[name='id']"
      );

      if (
        currentAtc &&
        fetchedAtc &&
        selectedIdInput &&
        fetchedIdInput &&
        String(selectedIdInput.value) ===
          String(fetchedIdInput.value) &&
        !currentAtc.disabled &&
        !fetchedAtc.disabled
      ) {
        currentAtc.innerHTML = fetchedAtc.innerHTML;
      }
    })
    .catch(function (error) {
      console.error(
        "Variant price update failed:",
        error
      );
    });
}


function swapHsContent(
  root,
  newRoot,
  selector
) {
  const currentElement = root.querySelector(
    selector
  );

  const newElement = newRoot.querySelector(
    selector
  );

  if (
    currentElement &&
    newElement
  ) {
    currentElement.innerHTML =
      newElement.innerHTML;
  }
}


/* ==========================================================
   IMAGE AND TEXT ACCORDION
========================================================== */

$(document).ready(function () {
  $(".hs-image-and-text-text-col-accordian-title-block")
    .on("click", function () {
      const parent = $(this).closest(
        ".hs-image-and-text-text-col-accordian"
      );

      const content = parent.find(
        ".hs-image-and-text-text-col-accordian-des-block"
      );

      $(".hs-image-and-text-text-col-accordian-des-block")
        .not(content)
        .slideUp();

      $(".hs-image-and-text-text-col-accordian")
        .not(parent)
        .removeClass("active");

      content.slideToggle();
      parent.toggleClass("active");
    });
});


/* ==========================================================
   TOOLTIP
========================================================== */

document.addEventListener(
  "DOMContentLoaded",
  function () {
    const tooltipBtn = document.querySelector(
      ".tool-tip"
    );

    const customTooltip = document.querySelector(
      ".custom-tool-tip"
    );

    if (
      tooltipBtn &&
      customTooltip
    ) {
      tooltipBtn.addEventListener(
        "click",
        function (event) {
          event.stopPropagation();

          customTooltip.classList.toggle(
            "active"
          );
        }
      );

      document.addEventListener(
        "click",
        function (event) {
          if (
            !customTooltip.contains(event.target) &&
            !tooltipBtn.contains(event.target)
          ) {
            customTooltip.classList.remove(
              "active"
            );
          }
        }
      );
    }
  }
);


/* ==========================================================
   EVENT SESSIONS ACCORDION
========================================================== */

$(document).ready(function () {
  $('.hs-event-sessions-text-accordian-title-block')
    .on('click', function () {
      const parent = $(this).closest(
        '.hs-event-sessions-text-accordian'
      );

      const description = parent.find(
        '.hs-event-sessions-text-accordian-desc-block'
      );

      $('.hs-event-sessions-text-accordian')
        .not(parent)
        .removeClass('active');

      $('.hs-event-sessions-text-accordian')
        .not(parent)
        .find(
          '.hs-event-sessions-text-accordian-desc-block'
        )
        .slideUp();

      parent.toggleClass('active');
      description.slideToggle();
    });
});


/* ==========================================================
   INGREDIENTS V2 ACCORDION
========================================================== */

$(document).ready(function () {
  $('.hs-ingredients-v2-accordian-title-arrow-block')
    .on('click', function () {
      const parent = $(this).closest(
        '.hs-ingredients-v2-accordian'
      );

      const content = parent.find(
        '.hs-ingredients-v2-accordian-image-text-block'
      );

      if (parent.hasClass('active')) {
        content.slideUp();
        parent.removeClass('active');
      } else {
        $('.hs-ingredients-v2-accordian')
          .removeClass('active');

        $('.hs-ingredients-v2-accordian-image-text-block')
          .slideUp();

        parent.addClass('active');
        content.slideDown();
      }
    });
});


/* ==========================================================
   MATCH HEIGHT FUNCTIONS
   ORIGINAL PRO CODE - UNCHANGED
========================================================== */

const matchHeight = function () {
  const screenWidth = window.innerWidth;

  const parentBlock = document.querySelector(
    '.hs-seminar-intro-innerblock'
  );

  const imageBlock = document.querySelector(
    '.hs-seminar-intro-image-v2-block'
  );

  if (
    !parentBlock ||
    !imageBlock
  ) {
    return;
  }

  if (
    screenWidth < 1600 &&
    screenWidth > 1024
  ) {
    const parentHeight =
      parentBlock.offsetHeight;

    imageBlock.style.height =
      parentHeight + 'px';

    const image = imageBlock.querySelector(
      'img'
    );

    if (image) {
      image.style.height = '100%';
      image.style.objectFit = 'cover';
    }
  } else {
    imageBlock.style.height = 'auto';
  }
};


const matchHeightv2 = function () {
  const screenWidth = window.innerWidth;

  const parentBlock = document.querySelector(
    '.hs-seminar-intro-innerblock'
  );

  const imageBlock = document.querySelector(
    '.hs-seminar-intro-image-block'
  );

  if (
    !parentBlock ||
    !imageBlock
  ) {
    return;
  }

  if (
    screenWidth < 1400 &&
    screenWidth > 1024
  ) {
    const parentHeight =
      parentBlock.offsetHeight;

    imageBlock.style.height =
      parentHeight + 'px';

    const image = imageBlock.querySelector(
      'img'
    );

    if (image) {
      image.style.height = '100%';
      image.style.objectFit = 'cover';
    }
  } else {
    imageBlock.style.height = 'auto';
  }
};


window.addEventListener(
  'load',
  function () {
    matchHeight();
    matchHeightv2();
  }
);

window.addEventListener(
  'resize',
  function () {
    matchHeight();
    matchHeightv2();
  }
);
